export const INTERVIEW_FORMAT_SELF_SCHEDULE_SLOT = "self-schedule-slot";
export const SELF_SCHEDULE_SELECT_SLOT = "self-schedule-select-slot";

const selfScheduleSlotModel = {
  slotsToAdd: [],
  slotsToDelete: [],
  candidates: [],
  interviewers: [],
  location: {
    jsonApi: "hasOne",
    type: "addresses"
  }
};

export default selfScheduleSlotModel;
